<template>
  <div class="introduce">
    <p align="center">
      <img class="introduce_img" src="../images/12introduce.jpg" />
    </p>
  </div>
</template>

<script>
export default {
  name: "12introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
